import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './button.component.module.styl';
import {FlatButton} from './flat-button/flat-button.component';

import type {FlatButtonProps} from './flat-button/flat-button.component';

const classNames = withCssModule(styles);

/**
 * A `<button>` that is visually styled as an inline hyperlink.
 *
 * Renders a `FlatButton` with the `button_link` CSS class and `role="link"` by
 * default. Use when the action should look like a text link but must remain a
 * native `<button>` (no navigation, no `href`).
 *
 * @deprecated It will be removed in 6 months 03-04-2026. Use FlatButton instead
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/story/buttons-button--link-buttons}
 */
export function ButtonLink({
    children,
    role = 'link',
    className,
    ...props
}: FlatButtonProps) {
    return (
        <FlatButton
            {...props}
            role={role}
            className={classNames('button_link', className)}>
            {children}
        </FlatButton>
    );
}
